module.exports = __webpack_public_path__ + "images/psp/College/unit-10x10.svg";